import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { SEOMeta } from '../components/SEOMeta';
import { Section, Container } from '../components/ui';
import { BlogGrid } from '../components/sections/blog';
import { RelatedPages } from '../components/RelatedPages';
import styles from './Blog.module.css';

interface Article {
  slug: string;
  title: string;
  description: string;
  date: string;
  author: string;
  category: string;
  readingTime: number;
  thumbnail: string;
}

export function Blog() {
  const { t, i18n } = useTranslation('blog');

  const articles = useMemo(() => {
    const raw = t('articles', { returnObjects: true }) as Record<string, Article>;
    return Object.values(raw).sort(
      (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
    );
  }, [t]);

  return (
    <>
      <SEOMeta title={t('meta.title')} description={t('meta.description')} />
      <link
        rel="alternate"
        type="application/rss+xml"
        title={t('meta.title')}
        href={i18n.language === 'en' ? '/en/rss.xml' : '/rss.xml'}
      />

      <Section variant="dark" className={styles.hero}>
        <Container>
          <div className={styles.heroContent}>
            <h1>{t('hero.title')}</h1>
            <p className={styles.heroSubtitle}>{t('hero.subtitle')}</p>
          </div>
        </Container>
      </Section>

      <Section variant="light">
        <Container>
          <BlogGrid articles={articles} />
        </Container>
      </Section>

      <RelatedPages currentFrPath="/blog" />
    </>
  );
}
